import { isFeatureFlagEnabled } from "@/services/featureFlagService";

export async function getALMFeatureFlagValue(): Promise<boolean> {
    try {
        return await isFeatureFlagEnabled("ALM");
    } catch (error) {
        console.error("Error checking ALM feature flag:", error);
        return false;
    }
}

export async function getToastMessageFeatureFlagValue(): Promise<boolean> {
    try {
        return await isFeatureFlagEnabled("FLUX-300-Custom-Toast-Message");
    } catch (error) {
        console.error("Error checking FLUX-300-Custom-Toast-Message feature flag:", error);
        return false;
    }
}

export async function getConfigureHomepagesAggridFeatureFlagValue(): Promise<boolean> {
    try {
        return await isFeatureFlagEnabled("FLUX-272-ConfigureHomepages_Aggrid");
    } catch (error) {
        console.error("Error checking FLUX-272-ConfigureHomepages_Aggrid feature flag:", error);
        return false;
    }
}

export async function getAXLDownloadLinkFeatureFlagValue(): Promise<boolean> {
    try {
        return await isFeatureFlagEnabled("FLUX-312-AXLDownloadLink");
    } catch (error) {
        console.error("Error checking FLUX-312-AXLDownloadLink feature flag:", error);
        return false;
    }
}

export async function getRebrandingStatusBadgesFeatureFlagValue(): Promise<boolean> {
    try {
        return await isFeatureFlagEnabled("FLUX-349-RebrandingStatusBadges");
    } catch (error) {
        console.error("Error checking FLUX-349-RebrandingStatusBadges feature flag:", error);
        return false;
    }
}

export async function getHomepageCardDesignerFeatureFlagValue(): Promise<boolean> {
    try {
        return await isFeatureFlagEnabled("FLUX-216-HomepageCardDesigner");
    } catch (error) {
        console.error("Error checking FLUX-216-HomepageCardDesigner feature flag:", error);
        return false;
    }
}

export async function getModalDialogsFeatureFlagValue(): Promise<boolean> {
    try {
        return await isFeatureFlagEnabled("FLUX-392-UpdateModelDialogsStyling");
    } catch (error) {
        console.error("Error checking FLUX-392-UpdateModelDialogsStyling feature flag:", error);
        return false;
    }
}

export async function getTabbedbarFeatureFlagValue(): Promise<boolean> {
    try {
        return await isFeatureFlagEnabled("FLUX-435-IconsToolbarToTabbedBar");
    } catch (error) {
        console.error("Error checking FLUX-435-IconsToolbarToTabbedBar feature flag:", error);
        return false;
    }
}

export async function getRightHandPanelsFeatureFlagValue(): Promise<boolean> {
    try {
        return await isFeatureFlagEnabled("FLUX-488-RightHandPanels");
    } catch (error) {
        console.error("Error checking FLUX-488-RightHandPanels feature flag:", error);
        return false;
    }
}

export async function getLeftNavContextMenuFeatureFlagValue(): Promise<boolean> {
    try {
        return await isFeatureFlagEnabled("FLUX-537-Left-Nav-Context-Menu");
    } catch (error) {
        console.error("Error checking FLUX-537-Left-Nav-Context-Menu feature flag:", error);
        return false;
    }
}